import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const CheckList = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m7.592 6.708 1.09 1.334 1.91-2.334m-2.68 5 1.092 1.334 1.909-2.334m-3.433 5 1.09 1.334 1.91-2.334m1.112-6.333h4m-3.68 4h4m-4.432 4h4m2.267 1.772.1-.442c.849-4.53.63-9.194-.637-13.624a1 1 0 0 0-.962-.706H5.336a1 1 0 0 0-.958 1.272c2.454 8.566-.395 13.143-.395 16.228a1.5 1.5 0 1 0 2.95-.383.422.422 0 0 1 .408-.529h12.1a.42.42 0 0 1 .375.229 1.5 1.5 0 0 1-1.336 2.183h-13"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(CheckList) as SvgIcon;
export { ForwardRef as ReactComponent };
